<template>
<div class="ui buttons" title="Not Prototyped">
    <button class="ui button">All</button>
    <button class="ui active button">2-Year</button>
    <button class="ui button">1-Year</button>
    <button class="ui button">3-Month</button>
    <button class="ui button">1-Month</button>
</div>
</template>

<script>
export default {
    name: 'time-range-selector',
}
</script>



// WEBPACK FOOTER //
// TimeRangeSelector.vue?f9d03b0e